import { IonDate } from "../components/IonDate";

const CheckNotNull = Symbol('CheckNotNull');

class Document {
    //from database
    public documentID: string = '';
    public document_cateogryID: string = '';
    public label: string = '';
    public description: string = '';
    public poster_url: string = '';
    public file_url:string = '';
    public extra_url: string = '';
    public viewable_member_typeIDs: string[] = [];
    public viewable_member_user_types: number[] = [];
    public viewable_committee_typeIDs: string[] = [];
    public creator_userID: string = '';
    public datetime_created: Date | null = null;
    public datetime_expired: Date | null = null;
    public updater_userID: string = '';
    public datetime_updated: Date | null = null;

    constructor(
        documentID: string,
        document_cateogryID: string,
        label: string,
        description: string,
        poster_url: string,
        file_url: string,
        extra_url: string,
        viewable_member_typeIDs: string,
        viewable_member_user_types: string,
        viewable_committee_typeIDs: string,
        creator_userID: string,
        datetime_created: string,
        datetime_expired: string,
        updater_userID: string,
        datetime_updated: string
    ) {
        this.documentID = this[CheckNotNull](documentID) ? documentID : '';
        this.document_cateogryID = this[CheckNotNull](document_cateogryID) ? document_cateogryID : '';
        this.label = this[CheckNotNull](label) ? label : '';
        this.description = this[CheckNotNull](description) ? description : '';
        this.poster_url = this[CheckNotNull](poster_url) ? poster_url : '';
        this.file_url = this[CheckNotNull](file_url) ? file_url : '';
        this.extra_url = this[CheckNotNull](extra_url) ? extra_url : '';
        this.viewable_member_typeIDs = this[CheckNotNull](viewable_member_typeIDs) ? viewable_member_typeIDs.split(',') : [];
        this.viewable_member_user_types = this[CheckNotNull](viewable_member_user_types) ? viewable_member_user_types.split(',').map((type: string) => parseInt(type)) : [];
        this.viewable_committee_typeIDs = this[CheckNotNull](viewable_committee_typeIDs) ? viewable_committee_typeIDs.split(',') : [];
        this.creator_userID = this[CheckNotNull](creator_userID) ? creator_userID : '';
        this.updater_userID = this[CheckNotNull](updater_userID) ? updater_userID : '';
        this.datetime_created = this[CheckNotNull](datetime_created) ? IonDate(datetime_created) : null;
        this.datetime_expired = this[CheckNotNull](datetime_expired) ? IonDate(datetime_expired) : null;
        this.datetime_updated = this[CheckNotNull](datetime_updated) ? IonDate(datetime_updated) : null;
    }

    private [CheckNotNull] = (value: string) => {
        if(value && value != null && value != 'null' && value.length > 0) 
            return true;
        else
            return false;
    }
}
export default Document;